// extracted by mini-css-extract-plugin
export default {"wrap":"KG-z","fullWidth":"LG-z","hideOnDesktop":"MG-z","content":"NG-z","hasOpenedNav":"OG-z","crumbsList":"PG-z","dropdownsWrap":"QG-z"};